import { BoldLabelText } from '@/components/BoldLabelText/BoldLabelText';
import { DescriptionCol, DescriptionRow } from '@/components/Description';
import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
  TransactionItemFormType,
} from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import { maxLengthWithSurrogate } from '@/libs/validation/maxLengthWithSurrogate';
import { FormInput, Label } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import styles from '../TransactionItemGeneralForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  method: UseFormReturn<TransactionItemFormType>;
  mode: TransactionItemDrawerMode;
};

const MAX_LENGTH = 20;

export const LabelInput: FC<Props> = memo(({ method, mode }) => {
  const { t } = useTranslation();
  const { control } = method;

  const inputProps = useMemo(() => {
    return {
      placeholder: t('transaction_items.text_placeholder'),
    };
  }, [t]);

  const rules = useMemo(() => {
    return {
      required: t('transaction_items.validation_message.required'),
      ...maxLengthWithSurrogate(
        MAX_LENGTH,
        t('transaction_items.validation_message.maxLength', {
          maxLength: MAX_LENGTH,
        })
      ),
    };
  }, [t]);

  return (
    <DescriptionRow>
      <DescriptionCol
        label={
          <Label
            testId='label'
            required={mode !== TransactionItemDrawerModeEnum.DETAIL}
          >
            <BoldLabelText>{t('transaction_items.table.label')}</BoldLabelText>
          </Label>
        }
        labelWidth='176px'
      />
      <DescriptionCol
        value={
          <>
            {mode === TransactionItemDrawerModeEnum.DETAIL ? (
              <div
                data-testid='label-detail'
                className={cx(styles['label-detail'])}
              >
                {method.getValues('label')}
              </div>
            ) : (
              <FormInput<TransactionItemFormType>
                name='label'
                control={control}
                inputId='label'
                testId='label'
                inputProps={inputProps}
                rules={rules}
              />
            )}
          </>
        }
      />
    </DescriptionRow>
  );
});
LabelInput.displayName = 'LabelInput';
